module.exports = __webpack_public_path__ + "static/media/team-member-05.3b297056.jpg";